<form [formGroup]="form">
  <label>{{ 'dashboard.edit.title' | translate }}</label>
  <input type="text" formControlName="title" class="form-control" />

  <label>{{ 'dashboard.edit.description' | translate }}</label>
  <input type="text" formControlName="description" class="form-control" />
</form>
